// TestHarness.js
import React, { useState, useEffect } from 'react';
import { IonApp, IonContent, setupIonicReact } from '@ionic/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import EditMetrics from './EditMetrics';

// Initialize Ionic React
setupIonicReact();

const EditMetricsTestHarness = () => {
  // Get auth data from URL parameters
  const [authData, setAuthData] = useState({
    member_id: null,
    user_id: null,
    auth_token: null
  });

  useEffect(() => { 
    const member_id = '195';
    const user_id = '14';
    const auth_token = 'eyJhbGciOiJBMjU2S1ciLCJlbmMiOiJBMjU2Q0JDLUhTNTEyIiwiemlwIjoiREVGIn0.U_6CiJWAXsFx_fBHZne2OAU4THGOGny6e859AAwyRx3kB8gQThVeEgctj_jPofp2GN0RZRP_FuOUDF9zAvmQktddCqjbpT6U.KCweK77Xj1rDHRaVDGKXhw.gDfrTzKhz8su8qnlUzxy47U-3oyoaG_aKrv9Eemjju2_42by66D8t8-paK4tnp4TD083ugevLBQIDtz6zpuUdIULrSyrleW-RzH7r68oIidNyIQrKvUaVkRfcwkYYnZwZ5ku9-TVo13nYm4ZV8U84_6s6CdyYfTCRr21KxWI_Es.G_MCE5khwhoJojB0lI0VCaBzI4sXZZLK8jBBvujpS6w';

    if (member_id && user_id && auth_token) {
      setAuthData({ member_id, user_id, auth_token });
      // Store in localStorage as EditMetrics expects
      localStorage.setItem('member_id', member_id);
      localStorage.setItem('user_id', user_id);
      localStorage.setItem('auth_token', auth_token);
    }
  }, []);

  return (
    <IonApp>
      <IonContent>
        {authData.member_id && authData.user_id && authData.auth_token ? (
          <EditMetrics 
            member_id={authData.member_id}
            user_id={authData.user_id}
            auth_token={authData.auth_token}
          />
        ) : (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Missing Authentication Data</h2>
            <p>Please provide member_id, user_id, and auth_token as URL parameters.</p>
            <p>Example: ?member_id=123&user_id=456&auth_token=abc...</p>
          </div>
        )}
      </IonContent>
    </IonApp>
  );
};

export default EditMetricsTestHarness;